import React from "react";

const Intercom = ({ email, id }) => {
  window.Intercom
    ? window.Intercom("boot", { app_id: "jb774wdc", email: email, user_id: id })
    : "";
  return null;
};

export default Intercom;



// WEBPACK FOOTER //
// ./src/components/Intercom/index.js